export default "__VITE_ASSET__b2fcf41b__"